<template>
  <div class="card-indicators d-flex row justify-center justify-space-between">
    <v-btn
      v-if="current < 1"
      fab
      small
      color="transparent"
      elevation="0"
      class="prev custom-elevation custom-outline"
    >
    </v-btn>
    <v-btn
      v-if="current > 0"
      fab
      small
      class="prev custom-elevation custom-border white-background"
      @click="$emit('prev')"
    >
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <div class="align-self-center">
      <span
        v-for="(item, i) in cards"
        :key="`indicator_${i}`"
        class="indicator mx-1 align-self-center"
        :class="{ 'active': i === current }"
      ></span>
    </div>
    <v-btn
      fab
      dark
      small
      color="primary"
      class="next custom-elevation"
      @click="$emit('next')"
    >
      <v-icon>arrow_forward</v-icon>
    </v-btn>
  </div>
</template>

<style scoped>
.card-indicators {
  position: relative;
}

  .prev {
    /* position: absolute; */
    left: 16px;
  }
  .next {
    /* position: absolute; */
    right: 16px;
  }

.indicator {
  background: rgba(0, 0, 0, .32);
  border-radius: 50%;
  display: inline-block;
  height: 8px;
  width: 8px;
}
  .indicator.active {
    background: rgba(0, 0, 0);
  }
</style>

<script>
export default {
  name: 'TutorialNavigation',
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
    current: {
      type: Number,
      default: 0,
    },
  },
};
</script>
